import { useEffect } from "react";
import { Marker, useMap, useMapEvents } from "react-leaflet";
import useSupercluster from "use-supercluster";
import mapMarker from "./map-marker.png";
const markerIcon = new L.icon({
  iconUrl: mapMarker,
  iconAnchor: [24, 30],
  iconSize: [40, 40],
});
const icons = {};
const fetchIcon = (count, size) => {
  if (!icons[count]) {
    icons[count] = L.divIcon({
      html: `<div class="cluster-marker" style="width: ${size}px; height: ${size}px;">
          ${count}
        </div>`,
    });
  }
  return icons[count];
};

const maxZoom = 17;

const MarkerCluster = ({
  points,
  bounds,
  zoom,
  markers,
  setBounds,
  setZoom,
}) => {
  const { clusters, supercluster } = useSupercluster({
    points: points,
    bounds: bounds,
    zoom: zoom,
    options: { radius: 75, maxZoom: maxZoom },
  });

  const map = useMap();
  const mapEvents = useMapEvents({
    zoomend: () => {
      updateMap();
    },
  });
  const updateMap = () => {
    const b = map.getBounds();
    setBounds([
      b.getSouthWest().lng,
      b.getSouthWest().lat,
      b.getNorthEast().lng,
      b.getNorthEast().lat,
    ]);
    setZoom(map.getZoom());
  };

  useEffect(() => {
    updateMap();
  }, [map]);

  return (
    <>
      {clusters &&
        clusters.map((cluster, index) => {
          const [longitude, latitude] = cluster.geometry.coordinates;
          const {
            cluster: isCluster,
            point_count: pointCount,
            facilityId,
          } = cluster.properties;
          if (isCluster) {
            return (
              <Marker
                key={`cluster-${cluster.id}`}
                position={[latitude, longitude]}
                icon={fetchIcon(
                  pointCount,
                  10 + (pointCount / points.length) * 40
                )}
                eventHandlers={{
                  click: (e) => {
                    const expansionZoom = Math.min(
                      supercluster.getClusterExpansionZoom(cluster.id),
                      maxZoom
                    );
                    map.setView([latitude, longitude], expansionZoom, {
                      animate: true,
                    });
                  },
                }}
              />
            );
          }
          return (
            <Marker
              key={`facility-${cluster.properties.facilityId}`}
              position={[latitude, longitude]}
              icon={markerIcon}
              eventHandlers={{
                click: (e) => {
                  markers
                    .find((marker) => marker.id === facilityId)
                    ?.onClick?.();
                },
              }}
            />
          );
        })}
    </>
  );
};

export default MarkerCluster;
